(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[937],{

/***/ 12873:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

!function(e,a){ true?a(exports,__webpack_require__(9084),__webpack_require__(14384),__webpack_require__(59665),__webpack_require__(55627),__webpack_require__(45721)):0}(this,function(e,a,t,c,o,n){function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var r=/*#__PURE__*/i(o),d=/*#__PURE__*/i(n),l={accordion:"_-ZYrB","accordion-header":"_O9cjN","accordion-content":"_klum0","accordion-icon":"_AdOBV","accordion-icon-inverted":"_AOEN3","accordion-detail-panel":"_uFFfY",hidden:"_uP6tT",visible:"_bkvVA","accordion-header-content":"_8APKo"},s=function(e,a){return a?e.close:e.open};e.Accordion=function(e){var o,i,u,f,b=e.header,m=e.children,g=e.className,v=void 0===g?"":g,h=e.onClick,p=e.rightAlign,y=void 0===p||p,k=e.classNames,w=void 0===k?{}:k,x=e.isExpandedState,E=void 0!==x&&x,C=e.detailPanelClasses,N=e.headerClasses,S=e.accordionIconClasses,_=e.accordianHeaderEleClasses,A=e.iconColor,T=void 0===A?"#9092A3":A,L=e.customIcon,q=void 0===L?null:L,I=e.disableIcon,B=void 0!==I&&I,D=n.useState(E),j=D[0],O=D[1],P=n.useState(E?"auto":0)[1],V=!!m,F=w.panelVisible,R=void 0===F?"":F,Y=r.default(((o={})[l.accordion]=!0,o[l["has-content"]]=V,o[l["accordion-expanded"]]=j,o)),H=r.default(((i={})[l["accordion-header"]]=!0,i)),K=q?"":r.default(((u={})[l["accordion-icon"]]=!0,u[l["accordion-icon-inverted"]]=j,u)),U=r.default(((f={})[l["accordion-detail-panel"]]=!0,f.hidden=!j,f.visible=j,f[R]=[R.length]&&j,f));return n.useEffect(function(){E||O(E),P(j?"auto":0)},[E]),d.default.createElement(c.Stack,{direction:c.StackDirection.TopDown,className:Y+" "+v},d.default.createElement(c.Stack,{className:H+" "+_,onClick:function(e){V&&(O(function(e){return!e}),h&&h(e))},direction:y?c.StackDirection.LeftToRight:c.StackDirection.RightToLeft},d.default.createElement("div",{className:l["accordion-header-content"]+" "+N},b),!!V&&!B&&d.default.createElement(a.Button,{mergeClasses:S?"override":"merge",className:K+" "+S+" bg-transparent",startIcon:q?s(q,j):d.default.createElement(t.UpTick,{colorCode:T})})),!!V&&d.default.createElement("div",{className:U+" "+C},m))}});


/***/ }),

/***/ 14384:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

!function(e,t){ true?t(exports,__webpack_require__(45721)):0}(this,function(e,t){function C(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=/*#__PURE__*/C(t);e.DiscountIcon=function(e){var t=e.colorCode,C=e.width,o=void 0===C?24:C,n=e.height,d=void 0===n?24:n;return i.default.createElement("svg",{width:o,height:d,viewBox:"0 0 "+o+" "+d,fill:"none",xmlns:"http://www.w3.org/2000/svg"},i.default.createElement("path",{d:"M11.2534 23.0764C11.6377 23.5518 12.3623 23.5518 12.7466 23.0764L14.3885 21.0453C14.6272 20.7499 15.0176 20.6231 15.3843 20.7217L17.9066 21.3998C18.4968 21.5585 19.0831 21.1326 19.1146 20.5222L19.249 17.9138C19.2685 17.5346 19.5098 17.2025 19.8645 17.0667L22.3036 16.1328C22.8744 15.9143 23.0983 15.2251 22.765 14.7128L21.3406 12.5235C21.1335 12.2052 21.1335 11.7948 21.3406 11.4765L22.765 9.28724C23.0983 8.77492 22.8744 8.0857 22.3036 7.86716L19.8645 6.93327C19.5098 6.79748 19.2685 6.4654 19.249 6.08615L19.1146 3.47781C19.0831 2.86742 18.4968 2.44145 17.9066 2.60015L15.3843 3.27831C15.0176 3.37691 14.6272 3.25007 14.3885 2.95474L12.7466 0.923575C12.3623 0.448248 11.6377 0.448248 11.2534 0.923575L9.61151 2.95474C9.37278 3.25007 8.98239 3.37691 8.61566 3.27831L6.09344 2.60015C5.50319 2.44145 4.91691 2.86742 4.88544 3.47781L4.751 6.08615C4.73145 6.4654 4.49018 6.79748 4.13553 6.93327L1.6964 7.86716C1.1256 8.0857 0.90166 8.77492 1.23499 9.28724L2.65936 11.4765C2.86647 11.7948 2.86647 12.2052 2.65936 12.5235L1.23499 14.7128C0.901661 15.2251 1.1256 15.9143 1.6964 16.1328L4.13553 17.0667C4.49018 17.2025 4.73145 17.5346 4.751 17.9138L4.88544 20.5222C4.91691 21.1326 5.50319 21.5585 6.09344 21.3998L8.61566 20.7217C8.98239 20.6231 9.37278 20.7499 9.61151 21.0453L11.2534 23.0764Z",fill:void 0===t?"#30a882":t}),i.default.createElement("path",{d:"M10.0782 11.5221C10.4105 11.5221 10.7353 11.4236 11.0116 11.239C11.2878 11.0544 11.5032 10.792 11.6303 10.485C11.7575 10.178 11.7907 9.84025 11.7259 9.51436C11.6611 9.18847 11.5011 8.88912 11.2661 8.65417C11.0312 8.41922 10.7318 8.25921 10.4059 8.19439C10.0801 8.12957 9.74227 8.16284 9.43529 8.28999C9.12831 8.41715 8.86593 8.63248 8.68132 8.90875C8.49672 9.18503 8.39819 9.50984 8.39819 9.84211C8.39819 10.2877 8.57519 10.715 8.89025 11.03C9.20532 11.3451 9.63263 11.5221 10.0782 11.5221ZM10.0782 9.12211C10.2206 9.12211 10.3598 9.16434 10.4782 9.24345C10.5966 9.32257 10.6889 9.43502 10.7434 9.56658C10.7979 9.69814 10.8121 9.84291 10.7844 9.98258C10.7566 10.1222 10.688 10.2505 10.5873 10.3512C10.4866 10.4519 10.3583 10.5205 10.2187 10.5483C10.079 10.5761 9.93422 10.5618 9.80266 10.5073C9.6711 10.4528 9.55865 10.3605 9.47954 10.2421C9.40042 10.1237 9.35819 9.98451 9.35819 9.84211C9.35819 9.65115 9.43405 9.46802 9.56908 9.33299C9.7041 9.19797 9.88724 9.12211 10.0782 9.12211Z",fill:"white"}),i.default.createElement("path",{d:"M13.9183 12.9624C13.586 12.9624 13.2612 13.0609 12.9849 13.2455C12.7086 13.4301 12.4933 13.6925 12.3662 13.9995C12.239 14.3065 12.2057 14.6443 12.2706 14.9702C12.3354 15.296 12.4954 15.5954 12.7303 15.8303C12.9653 16.0653 13.2646 16.2253 13.5905 16.2901C13.9164 16.3549 14.2542 16.3217 14.5612 16.1945C14.8682 16.0674 15.1306 15.852 15.3152 15.5758C15.4998 15.2995 15.5983 14.9747 15.5983 14.6424C15.5983 14.1968 15.4213 13.7695 15.1062 13.4545C14.7912 13.1394 14.3638 12.9624 13.9183 12.9624ZM13.9183 15.3624C13.7759 15.3624 13.6367 15.3202 13.5183 15.2411C13.3999 15.1619 13.3076 15.0495 13.2531 14.9179C13.1986 14.7864 13.1843 14.6416 13.2121 14.5019C13.2399 14.3623 13.3085 14.234 13.4092 14.1333C13.5099 14.0326 13.6382 13.964 13.7778 13.9362C13.9175 13.9085 14.0623 13.9227 14.1938 13.9772C14.3254 14.0317 14.4378 14.124 14.5169 14.2424C14.5961 14.3608 14.6383 14.5 14.6383 14.6424C14.6383 14.8334 14.5624 15.0165 14.4274 15.1515C14.2924 15.2865 14.1092 15.3624 13.9183 15.3624Z",fill:"white"}),i.default.createElement("path",{d:"M15.7134 8.28707C15.6737 8.2473 15.6266 8.21575 15.5747 8.19423C15.5228 8.1727 15.4672 8.16162 15.411 8.16162C15.3548 8.16162 15.2992 8.1727 15.2473 8.19423C15.1954 8.21575 15.1483 8.2473 15.1086 8.28707L8.283 15.1127C8.2038 15.1935 8.15906 15.3019 8.1582 15.4151C8.15808 15.4997 8.18306 15.5824 8.22999 15.6527C8.27693 15.7231 8.34369 15.778 8.42183 15.8104C8.49997 15.8428 8.58597 15.8512 8.66892 15.8347C8.75188 15.8181 8.82806 15.7773 8.8878 15.7175L15.7134 8.89187C15.7532 8.85219 15.7847 8.80505 15.8062 8.75316C15.8278 8.70127 15.8389 8.64565 15.8389 8.58947C15.8389 8.53329 15.8278 8.47767 15.8062 8.42578C15.7847 8.37389 15.7532 8.32675 15.7134 8.28707Z",fill:"white"}))},e.SearchIcon=function(e){var t=e.height,C=e.width,o=e.viewBoxHeight,n=e.viewBoxWidth,d=e.colorCode,l=e.className;return i.default.createElement("svg",{"data-testid":"search-icon",width:void 0===C?32:C,height:void 0===t?32:t,viewBox:"0 0 "+(void 0===n?32:n)+" "+(void 0===o?32:o),fill:"none",xmlns:"http://www.w3.org/2000/svg",className:void 0===l?"":l},i.default.createElement("path",{d:"M25.0942 24.5732L20.7667 20.2457M23.1045 14.625C23.1045 19.0204 19.5414 22.5835 15.146 22.5835C10.7506 22.5835 7.1875 19.0204 7.1875 14.625C7.1875 10.2297 10.7506 6.6665 15.146 6.6665C19.5414 6.6665 23.1045 10.2297 23.1045 14.625Z",stroke:void 0===d?"#9092A3":d,strokeWidth:"1.5",strokeLinecap:"round",strokeLinejoin:"round"}))},e.UpTick=function(e){var t=e.width,C=void 0===t?10:t,o=e.height,n=void 0===o?6:o,d=e.rotate,l=e.colorCode;return i.default.createElement("svg",{width:C,className:""+(void 0!==d&&d?null:"rotate-180"),height:n,viewBox:"0 0 "+C+" "+n,fill:"none",xmlns:"http://www.w3.org/2000/svg"},i.default.createElement("path",{d:"M0.83712 5.5028C1.16307 5.82646 1.68939 5.82553 2.0142 5.50072L5.24336 2.27156L8.48054 5.50169C8.80529 5.82573 9.33115 5.82544 9.65554 5.50104C9.98019 5.1764 9.98019 4.65005 9.65554 4.3254L5.83262 0.502481C5.50718 0.177044 4.97954 0.177044 4.65411 0.502481L0.835034 4.32155C0.508602 4.64799 0.509537 5.17752 0.83712 5.5028Z",fill:void 0===l?"#596C85":l}))}});


/***/ }),

/***/ 731:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

!function(e,t){ true?t(exports,__webpack_require__(9084),__webpack_require__(50686),__webpack_require__(14384),__webpack_require__(85265),__webpack_require__(45721)):0}(this,function(e,t,r,a,o,n){function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=/*#__PURE__*/i(n);e.SimpleDropdown=function(e){var i=e.dropdownContent,u=e.dropDownText,c=e.dropdownDefaultState,d=e.className,s=void 0===d?"":d,p=n.useState(void 0!==c&&c),f=p[0],y=p[1],b=r.useOnClickOutside(function(){y(!1)});return l.default.createElement("div",{ref:b,className:"relative "+s},l.default.createElement(t.Button,{type:"button",className:"font-medium inline-flex w-full px-3 py-2 rounded text-grey-850 transition duration-150 ease-in-out  items-center justify-center sm:flex sm:w-auto",id:"menu-button",onClick:function(){y(!f)},"aria-expanded":"true","aria-haspopup":"true",mergeClasses:"override"},u,l.default.createElement(o.Text,{type:"span",className:(f?"rotate-180":"")+"  px-2 "},l.default.createElement(a.UpTick,{colorCode:"#596C85"}))),f?i:null)}});


/***/ }),

/***/ 59665:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

!function(t,e){ true?e(exports,__webpack_require__(55627),__webpack_require__(45721)):0}(this,function(t,e,n){function i(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}var o=/*#__PURE__*/i(e),r=/*#__PURE__*/i(n);function a(){return a=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var i in n)({}).hasOwnProperty.call(n,i)&&(t[i]=n[i])}return t},a.apply(null,arguments)}var c,f=["direction","children","className","onClick"];t.StackDirection=void 0,(c=t.StackDirection||(t.StackDirection={}))[c.LeftToRight=0]="LeftToRight",c[c.RightToLeft=1]="RightToLeft",c[c.TopDown=2]="TopDown",c[c.BottomUp=3]="BottomUp";var s=n.forwardRef(function(e,n){var i,c=e.direction,s=void 0===c?t.StackDirection.LeftToRight:c,l=e.children,u=e.className,d=e.onClick,p=function(t,e){if(null==t)return{};var n={};for(var i in t)if({}.hasOwnProperty.call(t,i)){if(-1!==e.indexOf(i))continue;n[i]=t[i]}return n}(e,f),h=o.default(((i={})._nNp4M=!1,i[function(e){switch(e){case t.StackDirection.LeftToRight:return"_9St2D";case t.StackDirection.RightToLeft:return"_ddpNj";case t.StackDirection.TopDown:return"_3xW1Z";case t.StackDirection.BottomUp:return"_RKbGB"}}(s)]=!0,i._3UWdX=!0,i));return r.default.createElement("div",a({ref:n,className:h+" "+u,onClick:function(t){d&&d(t)}},p),l)});s.displayName="Stack",t.Stack=s});


/***/ }),

/***/ 65712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O5": function() { return /* binding */ getHeaderDetails; },
/* harmony export */   "Ue": function() { return /* binding */ searchApi; },
/* harmony export */   "XB": function() { return /* binding */ logoutApi; }
/* harmony export */ });
/* harmony import */ var _config_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50595);
/* harmony import */ var _pages_services_planSeoSlug_api_transformer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89687);


var getHeaderDetails = function getHeaderDetails() {
  return _config_axios__WEBPACK_IMPORTED_MODULE_0__/* .mpBackend.get */ .LZ.get("header").then(function (data) {
    return (0,_pages_services_planSeoSlug_api_transformer__WEBPACK_IMPORTED_MODULE_1__/* .transformHeaderData */ .cy)(data);
  });
};
var logoutApi = function logoutApi() {
  return _config_axios__WEBPACK_IMPORTED_MODULE_0__/* .mpBackend.get */ .LZ.get("user/logout").then(function (data) {
    return data;
  })["catch"](function () {
    console.log('logout api failing');
  });
};
var searchApi = function searchApi(query) {
  return _config_axios__WEBPACK_IMPORTED_MODULE_0__/* .mpBackend.get */ .LZ.get("search?query=".concat(query)).then(function (data) {
    return data;
  })["catch"](function () {
    console.log('search api failing');
  });
};

/***/ }),

/***/ 51143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ HamburgerSidebar; }
});

// EXTERNAL MODULE: ../.yarn/__virtual__/@cleartax-wg-library-drawer-virtual-1694e749cc/1/mp-library/packages/components/drawer/dist/index.js
var dist = __webpack_require__(21502);
// EXTERNAL MODULE: ../.yarn/__virtual__/@cleartax-wg-library-hooks-virtual-3f1c509501/1/mp-library/packages/hooks/dist/index.js
var hooks_dist = __webpack_require__(50686);
// EXTERNAL MODULE: ../.yarn/__virtual__/@cleartax-wg-library-typography-virtual-3da32b9aec/1/mp-library/packages/components/typography/dist/index.js
var typography_dist = __webpack_require__(85265);
// EXTERNAL MODULE: ../.yarn/__virtual__/next-virtual-982f7924cf/0/cache/next-npm-12.2.5-8247fb1613-e8fcbd93d7.zip/node_modules/next/router.js
var next_router = __webpack_require__(43001);
// EXTERNAL MODULE: ../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(45721);
// EXTERNAL MODULE: ./src/shared/context/user/index.ts
var user = __webpack_require__(87275);
// EXTERNAL MODULE: ./src/shared/components/layout-components/headers/default-header/header.api.tsx
var header_api = __webpack_require__(65712);
// EXTERNAL MODULE: ./src/shared/components/layout-components/headers/default-header/my-account-dropdown/static.ts
var my_account_dropdown_static = __webpack_require__(62638);
;// CONCATENATED MODULE: ./src/shared/components/layout-components/headers/default-header/mobile-header/static.ts
var MY_TOOLS_DROPDOWN = [{
  name: ' Income Tax Calculator',
  href: '/paytax/TaxCalculator'
}, {
  name: 'Refund status checker',
  href: '/s/income-tax-refund'
}, {
  name: 'HRA calculator',
  href: '/paytax/TaxCalculator'
}, {
  name: 'Rent receipt Generator',
  href: '/save/rent'
}];
// EXTERNAL MODULE: ./src/shared/components/layout-components/headers/default-header/mobile-header/hamburger-sidebar/sidebar-dropdown.tsx
var sidebar_dropdown = __webpack_require__(73159);
// EXTERNAL MODULE: ../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(86521);
;// CONCATENATED MODULE: ./src/shared/components/layout-components/headers/default-header/mobile-header/hamburger-sidebar/index.tsx
/* provided dependency */ var Buffer = __webpack_require__(32777)["Buffer"];












var HamburgerSidebar = function HamburgerSidebar(_ref) {
  var open = _ref.open,
      closeCB = _ref.closeCB;
  var userContext = (0,user/* useUserCtx */.X)();
  var router = (0,next_router.useRouter)();
  var returnPath = Buffer.from(router.asPath).toString('base64');

  var _useApi = (0,hooks_dist.useApi)({}, header_api/* logoutApi */.XB),
      logout = _useApi.request,
      logoutRes = _useApi.data;

  (0,react.useEffect)(function () {
    if (logoutRes.success) userContext.logout();
  }, [logoutRes]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(dist.Drawer, {
    onCloseCallBack: function onCloseCallBack() {
      return closeCB(false);
    },
    isOpen: open,
    direction: 'right',
    width: '3/4',
    minWidth: 300,
    animationDuration: 500,
    top: '48px',
    hideIcon: true,
    closeOnClickOverlay: true,
    children: [userContext.isLoggenIn ? /*#__PURE__*/(0,jsx_runtime.jsx)(sidebar_dropdown/* SidebarDropDown */.J, {
      contentHeader: "My Account",
      contentArr: my_account_dropdown_static/* MY_ACCOUNT_DROPDOWN */.i,
      onClickCB: logout
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
      type: "a",
      href: "".concat("https://accounts.cleartax.in/v2?product=cleartax", "&return_path=").concat(returnPath),
      mergeClasses: "override",
      className: "block border-b-sm border-b-grey-300 border-dashed pl-3 text-base text-brand-1000 font-semibold py-5",
      children: "Login/Register"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
      type: "a",
      href: "https://www.clear.in/s/contact-us",
      mergeClasses: "override",
      className: "block border-b-sm border-b-grey-300 border-dashed pl-3 text-base text-brand-1000 font-semibold py-5",
      children: "Support"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(sidebar_dropdown/* SidebarDropDown */.J, {
      contentHeader: "Tools",
      contentArr: MY_TOOLS_DROPDOWN
    })]
  });
};

/***/ }),

/***/ 73159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SidebarDropDown; }
/* harmony export */ });
/* harmony import */ var _opt_cleartax_mp_website_yarn_virtual_next_virtual_982f7924cf_0_cache_next_npm_12_2_5_8247fb1613_e8fcbd93d7_zip_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24834);
/* harmony import */ var _cleartax_wg_library_accordian__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12873);
/* harmony import */ var _cleartax_wg_library_accordian__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cleartax_wg_library_accordian__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _cleartax_wg_library_typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85265);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86521);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_cleartax_mp_website_yarn_virtual_next_virtual_982f7924cf_0_cache_next_npm_12_2_5_8247fb1613_e8fcbd93d7_zip_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SidebarDropDown = function SidebarDropDown(_ref) {
  var contentHeader = _ref.contentHeader,
      contentArr = _ref.contentArr,
      _ref$headerClasses = _ref.headerClasses,
      headerClasses = _ref$headerClasses === void 0 ? 'text-base text-brand-1000 mb-4 font-semibold' : _ref$headerClasses,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'border-y-sm border-y-grey-300 border-dashed pl-3' : _ref$className,
      onClickCB = _ref.onClickCB;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
    className: className,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_cleartax_wg_library_accordian__WEBPACK_IMPORTED_MODULE_1__.Accordion, {
      header: contentHeader,
      accordianHeaderEleClasses: headerClasses,
      children: contentArr.map(function (item, idx) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_cleartax_wg_library_typography__WEBPACK_IMPORTED_MODULE_2__.Text, _objectSpread(_objectSpread({
          type: "a",
          href: item.href,
          weight: "normal",
          className: "text-brand-1000 cursor-pointer block py-3 ".concat(idx === 0 ? 'pt-0' : '', " pl-4 hover:text-brand-700"),
          textSize: "base"
        }, item.name === 'Logout' && onClickCB ? {
          onClick: function onClick() {
            return onClickCB();
          }
        } : {}), {}, {
          children: item.name
        }), item.name);
      })
    })
  });
};

/***/ }),

/***/ 15782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ MyAccountDropdown; }
/* harmony export */ });
/* harmony import */ var _cleartax_wg_library_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50686);
/* harmony import */ var _cleartax_wg_library_typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85265);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45721);
/* harmony import */ var _context_user__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87275);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40117);
/* harmony import */ var _header_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65712);
/* harmony import */ var _static__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62638);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86521);








var MyAccountDropdown = function MyAccountDropdown() {
  var borderClasses = 'border-b-sm border-dashed border-b-grey-300';
  var textClasses = 'text-brand-1000 text-base font-medium';
  var containerClasses = 'mx-2 cursor-pointer flex justify-between items-center py-3 pl-3';

  var _useApi = (0,_cleartax_wg_library_hooks__WEBPACK_IMPORTED_MODULE_0__.useApi)({}, _header_api__WEBPACK_IMPORTED_MODULE_5__/* .logoutApi */ .XB),
      logout = _useApi.request,
      logoutRes = _useApi.data;

  var userContext = (0,_context_user__WEBPACK_IMPORTED_MODULE_3__/* .useUserCtx */ .X)();
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (logoutRes.success) userContext.logout();
  }, [logoutRes]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
    className: "origin-top-right bg-white w-48 absolute sm:relative mt-2 rounded-b-lg shadow-lg sm:shadow-none focus:outline-none",
    children: _static__WEBPACK_IMPORTED_MODULE_6__/* .MY_ACCOUNT_DROPDOWN.map */ .i.map(function (dropdownItem, idx, arr) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: "w-full hover:bg-brand-200 ".concat(idx + 1 === arr.length ? 'rounded-b-lg' : ''),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_cleartax_wg_library_typography__WEBPACK_IMPORTED_MODULE_1__.Text, {
          type: "a",
          mergeClasses: "override",
          href: dropdownItem.href,
          className: "".concat(borderClasses, " ").concat(textClasses, " ").concat(containerClasses),
          onClick: function onClick() {
            (0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .trackAction */ .X2)('click', '', {
              label: "top_nav_menu_".concat(dropdownItem.name)
            });
            if (dropdownItem.name === 'Logout') logout();
          },
          children: dropdownItem.name
        })
      }, dropdownItem.name);
    })
  });
};

/***/ }),

/***/ 62638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ SUPPORT_AGENT_DROPDOWN; },
/* harmony export */   "i": function() { return /* binding */ MY_ACCOUNT_DROPDOWN; }
/* harmony export */ });
var MY_ACCOUNT_DROPDOWN = [{
  name: 'My Tax Returns',
  href: '/filing/itr-filings'
}, {
  name: 'My Orders',
  href: '/services/my_orders'
}, {
  name: 'My Documents',
  href: '/services/library'
}, {
  name: 'Profile',
  href: '/filing/profile'
}, {
  name: 'Support',
  href: '/s/contact-us'
}, {
  name: 'Logout',
  href: ''
}];
var SUPPORT_AGENT_DROPDOWN = [{
  name: 'Profile',
  href: '/filing/profile'
}, {
  name: 'Logout',
  href: ''
}];

/***/ }),

/***/ 97992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ HamburgerIcon; }
});

// EXTERNAL MODULE: ../.yarn/__virtual__/next-virtual-982f7924cf/0/cache/next-npm-12.2.5-8247fb1613-e8fcbd93d7.zip/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(24834);
// EXTERNAL MODULE: ../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(86521);
;// CONCATENATED MODULE: ./src/shared/icons/hamburger.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var HamburgerIcon = function HamburgerIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({
    "data-testid": "hamburger",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M20 18H13M20 6H4H20ZM20 12H4H20Z",
      stroke: "#314259",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
};
;// CONCATENATED MODULE: ./src/shared/icons/index.ts



/***/ }),

/***/ 89872:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 81110:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 59154:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 49548:
/***/ (function() {

/* (ignored) */

/***/ })

}]);